// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.

import Vue from 'vue';

// Setup Error Logging for production
// if (process.env.NODE_ENV === 'production') {
// window.Raven
//   .config('https://ff50283d45dc461a961f487b91926db6@app.getsentry.com/72611')
//   .install();
// }

import App from './App';
import router from './router';
import store from './vuex/store';

import patchTimezoneAbbreviations from './timezone-abbreviations';
patchTimezoneAbbreviations();

require('material-design-lite/material.js');

Vue.config.productionTip = false;

const events = new Vue();

Vue.prototype.$events = events;

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  template: '<App/>',
  components: {App},
  store
});
